A position opening in a paginated list.
